/**
 * 招待ページ - ローディング状態
 */

import { Loading } from "components/ui/Loading/Loading";
import type { FC } from "react";

export const InvitationLoading: FC = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-base-200 px-4">
      <div className="card w-full max-w-lg bg-base-100 shadow-xl mx-auto">
        <div className="card-body items-center">
          <Loading size="md" />
          <p className="text-base-content/70 mt-4">読み込み中...</p>
        </div>
      </div>
    </div>
  );
};
